import * as u from '@virtuoso.dev/urx';
export var domIOSystem = u.system(function () {
    var scrollContainerState = u.stream();
    var scrollTop = u.stream();
    var deviation = u.statefulStream(0);
    var smoothScrollTargetReached = u.stream();
    var statefulScrollTop = u.statefulStream(0);
    var viewportHeight = u.stream();
    var scrollHeight = u.stream();
    var headerHeight = u.statefulStream(0);
    var footerHeight = u.statefulStream(0);
    var scrollTo = u.stream();
    var scrollBy = u.stream();
    var scrollingInProgress = u.statefulStream(false);
    var react18ConcurrentRendering = u.statefulStream(false);
    u.connect(u.pipe(scrollContainerState, u.map(function (_a) {
        var scrollTop = _a.scrollTop;
        return scrollTop;
    })), scrollTop);
    u.connect(u.pipe(scrollContainerState, u.map(function (_a) {
        var scrollHeight = _a.scrollHeight;
        return scrollHeight;
    })), scrollHeight);
    u.connect(scrollTop, statefulScrollTop);
    return {
        // input
        scrollContainerState: scrollContainerState,
        scrollTop: scrollTop,
        viewportHeight: viewportHeight,
        headerHeight: headerHeight,
        footerHeight: footerHeight,
        scrollHeight: scrollHeight,
        smoothScrollTargetReached: smoothScrollTargetReached,
        react18ConcurrentRendering: react18ConcurrentRendering,
        // signals
        scrollTo: scrollTo,
        scrollBy: scrollBy,
        // state
        statefulScrollTop: statefulScrollTop,
        deviation: deviation,
        scrollingInProgress: scrollingInProgress,
    };
}, [], { singleton: true });
